
<template>
  <v-form class="itemSection">
    <v-text-field
      v-if="textField"
      :class="`${isDisabled ? 'transformer-field-disabled' : 'transformer-field'}`"
      ref="transFld"
      v-model="editText"
      :disabled="isDisabled"
      :readonly="isDisabled"
      :dense="isDisabled"
      :hide-details="isDisabled"
      :placeholder="placeholder"
      :value="item.name"
    />
    <v-textarea
      v-if="textArea"
      :class="`${isDisabled ? 'transformer-field-disabled' : 'transformer-field'}  textArea`"
      ref="transFld"
      v-model="editTextArea"
      :disabled="isDisabled"
      :readonly="isDisabled"
      :dense="isDisabled"
      :hide-details="isDisabled"
    />

    <div class="icons" v-if="edit">
      <v-icon v-if="isDisabled" @click.stop.prevent="editClick()">$sl-edit</v-icon>      
      <v-icon v-if="isDisabled" @click.stop.prevent="deleteClick()">$sl-delete</v-icon>
      <v-icon v-if="!isDisabled" @click.stop.prevent="saveClick(item)">mdi-content-save-outline</v-icon>
      <v-icon v-if="!isDisabled" @click.stop.prevent="cancelClick()">$sl-redo</v-icon>
    </div>
  </v-form>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
// @group Common
// Provides the TransformerTextField component.
export default {
  name: 'TransformerTextField',

  data: () => ({
    isDisabled: true,
    editText: '',
    editArea: '',
    textField: true,
    textArea: false,
    editTextArea: ''
  }),

  props: {
    //has Label , type string,default empty
    label: String,
    //has Placeholder , type string,default empty
    placeholder: String,
    //has Type , type string,default empty
    type: String,
    //has Item , type string,default empty
    item: Object,
     // Should fields be editable
    edit: {
      // `true` / `false`
      type: Boolean,
       // The default value is: `false`
      default: false
    },
    //has section id, type Integer,default empty
    sectionId: Number,
    //has detail id , type Integer,default empty
    detailId: Number,
    //has part id , type Integer,default empty
    partId: Number,
     // Should field be disabled
    disabled: {
    // `true` / `false`
      type: Boolean,
       // The default value is: `True`
      default: true
    }
  },

  created() {
    this.isDisabled = this.disabled
    if(!(this.item && this.item.id && (this.item.text || this.item.name))){
      this.textField=false
      this.textArea=false
      return
    }
    else if (this.type == 'item') {
      this.editTextArea = this.item.text
      this.textArea = true
      this.textField = !this.textArea
    } else {
      this.editText = this.item.name
      this.textArea = !this.textField
    }
  },
  methods: {
    getShorter(value) {
      if (!value && typeof value != 'string') return ''
      if (value.length > 15) return value.substring(0, 14) + '...'
      else return value
    },
    editClick() {      
      this.$nextTick(() => this.$refs.transFld.focus())
      this.isDisabled = !this.isDisabled      
    },
    cancelClick() {
      if (this.type == 'item') {
        this.editTextArea = this.item.text
      } else {
        this.editText = this.item.name
      }
      this.isDisabled = !this.isDisabled
    },
     // @vuese
    //- Used to delete text description
    deleteClick() {
      if (
        this.type == 'item' ||
        this.type == 'section' ||
        this.type == 'element'
      ) {
        var msg = ''
        var method = ''
        method =
          'delete' + this.type.charAt(0).toUpperCase() + this.type.slice(1)
        if (this.type == 'item') msg = 'Beskrivningen raderad.'
        else msg = "'" + this.item.name + "'" + ' raderad.'        
        API[method](this.item.id)
          .then(response => {
            this.$events.fire('showInfo', msg)            
             // Fire textUpdated event
             // @arg The argument is Object
            this.$emit('textUpdated', {
              responseId: response.data.deletedRows,
              name: this.item.name
            })
          })
          .catch(error => {
            console.log('There was an error:', error.response)
             // Fire textUpdated event
             // @arg The argument is Object
            this.$emit('textUpdated', {
              responseId: -1,
              name: this.item.name
            })
          })
      }
    },
    // @vuese
    //- Used to delete text description
    saveClick() {
      if (
        this.type == 'item' ||
        this.type == 'section' ||
        this.type == 'element'
      ) {
        var msg = ''
        var method = ''
        var newItem = this.item
        var data
        var id = this.item.id
        method =
          'update' + this.type.charAt(0).toUpperCase() + this.type.slice(1)
        if (this.type == 'item') {
          newItem.name = this.editTextArea
          data = {
            text: newItem.name,
            partId: this.partId,
            detailId: this.detailId
          }          
          msg = "'" + this.getShorter(newItem.name) + "'" + ' är nu uppdaterad.'
        } else if (this.type == 'element') {
          newItem.name = this.editText
          data = {name: newItem.name, sectionId: this.sectionId}          
          msg = "'" + newItem.name + "'" + ' uppdaterad.'
        } else {
          data = {data: newItem}          
          newItem.name = this.editText
          msg = "'" + newItem.name + "'" + ' uppdaterad.'
        }                
        
        API[method](data, id)
          .then(response => {
            this.$events.fire('showInfo', msg)
            console.log('success')
            // Fire textUpdated event
             // @arg The argument is Object
            this.$emit('textUpdated', {
              responseId: response.data.updatedRows
            })
          })
          .catch(error => {
            console.log('There was an error:', error.response)
            this.$emit('textUpdated', {
              responseId: -1
            })
          })
          this.isDisabled=!this.isDisabled
      }
    }
  }
}
</script>

<style lang="scss">
.transformer-field-disabled .v-input__control .v-input__slot label,
.transformer-field-disabled .v-input__control .v-input__slot input {
  color: black !important;
}
.transformer-field-disabled .v-input__control .v-input__slot:before {
  border-style: none !important;
}
.v-text-field.v-input--dense:not(.v-text-field--outlined):not(.v-text-field--solo)
  input {
  padding: 0 !important;
}
.theme--light.v-input--is-disabled .v-label,
.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: black !important;
}
.icons {
  .v-icon {
    width: 40px;

    &:hover {
      color: var(--v-secondary-base) !important;
      font-size: 32px;
    }
  }
}
.itemSection {
  display: flex;
  width: 100%;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
}
</style>